<template>
  <div class="holder">
    <input
      :id="id"
      :type="type"
      autocomplete="email"
      v-model="data"
      class="form-control"
      @input="emmitEvent"
      @keydown="emitKeydown"
      @change="emitChange"
      maxlength="100"
    >
    <span class="counter text-muted" v-if="maxlength">{{charactersLeft}}</span>
    <div v-if="withAgreement" class="mts">
      <fieldset>
      <legend style="font-size:14px;margin:auto;">{{$t('input_email_agreement_inline')}}</legend>
      <ic-radio-group
        :id="id + '_agreement'"
        :options="agreementOptions"
        v-model="emailAgreement"
        @input="emmitAgreement"
      ></ic-radio-group>
      </fieldset>
    </div>
  </div>
</template>

<script>
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";

export default {
  name: "IcInputEmail",
  props: {
    id: { type: String },
    value: { type: [String, Number] },
    agreement: { type: [Boolean, Number], default: false },
    type: { type: String, default: "email" },
    v: { type: Object },
    withAgreement: { type: Boolean, default: false }
    
  },
  data() {
    return {
      maxlength: 100,
      data: this.value,
      emailAgreement: this.agreement,
      agreementInitial: true,
      agreementOptions: [
        { id: 1, name: this.$t("label_yes") },
        { id: 0, name: this.$t("label_no") }
      ]
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = newValue;
      }
    }
  },
  computed: {
    charactersLeft() {
        var char = this.data.length,
            limit = this.maxlength;

        return (char) + " / " + limit + "";
    }
  },  
  methods: {
    emmitAgreement(event) {
      this.$emit("agreement:update", event);
      if (this.v) {
        this.v.$touch();
      }
    },
    emmitEvent(event) {
      this.$emit("input", event.target.value);
      if (this.agreementInitial) {
        this.emailAgreement = 1;
        this.agreementInitial = false;
      }

      if (this.v) {
        this.v.$touch();
      }
    },
    emitKeydown(event) {
      this.$emit("keydown", event);
      if (this.v) {
        this.v.$touch();
      }
    },
    emitChange(event) {
      this.$emit("change", event);
      if (this.v) {
        this.v.$touch();
      }
    }
  },
  components: {
    IcRadioGroup
  }
};
</script>

<style>
.holder {
  position: relative;
}
.counter {
  position: absolute;
margin-top: -34px;
right: 10px;
font-size: 70%;
}
</style>
